// The opening ritual's timing.
//
// The app opens on a sheet of glass, the wordmark inscribes itself into it, and
// you swipe up to come in. That is a ceremony the first time and a toll booth
// the twentieth, so a repeat open is faster, quieter, and lifts itself if you
// do nothing. The gesture still works either way, because someone who wants the
// ritual should be able to have it.

export interface OpeningPlan {
  /** How long the wordmark takes to etch itself, in ms. */
  inscribeMs: number;
  /** When the swipe-up invitation appears, in ms. */
  hintAtMs: number;
  /** Lift on its own after this long, or null to wait for the person. */
  autoLiftMs: number | null;
  /** The tagline only earns its place on a first look. */
  showTagline: boolean;
}

export function openingPlan(openedBefore: boolean): OpeningPlan {
  if (!openedBefore) {
    return { inscribeMs: 1700, hintAtMs: 2300, autoLiftMs: null, showTagline: true };
  }
  return { inscribeMs: 620, hintAtMs: 480, autoLiftMs: 1250, showTagline: false };
}

// An upward flick, not a scroll and not a tap. Distance rules out a jitter of
// the thumb; direction rules out someone pulling down to refresh.
export function isSwipeUp(startY: number, endY: number, minDistance = 36): boolean {
  return startY - endY >= minDistance;
}
